import { cn, putComma } from "@/lib/utils";
import { useState } from "react";
import { useSelector } from "react-redux";

function PositionsDetailsClosed() {
    const [isOpen, setOpen] = useState(false);
    const { positionsDetails } = useSelector((state) => state.stocksDetails);

    return (
        <div className="font-Inter  mx-4">
            <hr className="my-4" />
            <div
                className={cn(
                    "text-primary font-semibold text-base text-center cursor-pointer transition-all max-h-96 overflow-hidden opacity-100",
                    isOpen && "opacity-0 max-h-0"
                )}
                onClick={() => setOpen((pre) => !pre)}
            >
                View tradebook
            </div>
            <div
                className={cn(
                    "flex flex-col items-start gap-4 self-stretch transition-all max-h-0 overflow-hidden opacity-0",
                    isOpen && "opacity-100 max-h-96"
                )}
            >
                {positionsDetails?.tot_buy_qty > 0 && (
                    <div className="flex flex-col items-start self-stretch gap-3">
                        <div
                            className={`border px-2 flex justify-center items-center rounded font-bold bg-white text-[10px] border-[#26A649] text-[#26A649]`}
                        >
                            Buy
                        </div>
                        <div className=" w-full flex justify-between gap-4">
                            <div className="flex flex-col justify-center text-[#747474] font-medium text-xs ">
                                Qty.
                                <div className="text-black text-xs leading-5 font-semibold">
                                    {positionsDetails?.tot_buy_qty}
                                </div>
                            </div>
                            <div className="flex flex-col justify-center text-[#747474] font-medium text-xs ">
                                Price
                                <div className="text-black text-xs leading-5 font-semibold">
                                    ₹{putComma(positionsDetails?.buy_avg)}
                                </div>
                            </div>
                            <div className="flex flex-col justify-center text-[#747474] font-medium text-xs ">
                                Value
                                <div className="text-black text-xs leading-5 font-semibold">
                                    ₹{putComma(positionsDetails?.tot_buy_val)}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {positionsDetails?.tot_sell_qty > 0 && (
                    <div className="flex flex-col items-start self-stretch gap-3">
                        <div
                            className={`border px-2 flex justify-center items-center rounded font-bold bg-white text-[10px] border-[#EB4E2C] text-[#EB4E2C]`}
                        >
                            Sell
                        </div>
                        <div className=" w-full flex justify-between gap-4">
                            <div className="flex flex-col justify-center text-[#747474] font-medium text-xs ">
                                Qty.
                                <div className="text-black text-xs leading-5 font-semibold">
                                    {positionsDetails?.tot_sell_qty}
                                </div>
                            </div>
                            <div className="flex flex-col justify-center text-[#747474] font-medium text-xs ">
                                Price
                                <div className="text-black text-xs leading-5 font-semibold">
                                    ₹{putComma(positionsDetails?.sell_avg)}
                                </div>
                            </div>
                            <div className="flex flex-col justify-center text-[#747474] font-medium text-xs ">
                                Value
                                <div className="text-black text-xs leading-5 font-semibold">
                                    ₹{putComma(positionsDetails?.tot_sell_val)}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <hr className="my-4" />
        </div>
    );
}

export default PositionsDetailsClosed;
